import { SupervisorPinCodeProps } from "./ISupervisorPinCode";
import { Stack, Typography } from "@mui/material";
import useSupervisorPinCode from "./useSupervisorPinCode";
import { NumberInputFields } from "components/NumberInputFields/NumberInputFields";

/**
 * DOM contract: the digit inputs are `supervisor-pin-0` ... `supervisor-pin-3`
 * (see {@link NumberInputFields}) and the resolved supervisor name, which is
 * what tells a spec the pin was accepted, is `supervisor-pin-name` with
 * `data-pin-error` mirroring the rejected state - the error is styled-only, so
 * colour alone is not assertable.
 */
export default function SupervisorPinCode(props: SupervisorPinCodeProps) {
  const { HandleOnCompletePinCode, superVisorName, isError, colors } =
    useSupervisorPinCode(
      props.HandleOnCompletePinCode,
      props.HandleOnManyWrongAttempts,
      props.posId,
    );

  return (
    <Stack
      spacing={2}
      sx={{
        justifyContent: "center",
        alignItems: "center"
      }}>
      <NumberInputFields
        fieldCount={4}
        onComplete={HandleOnCompletePinCode}
        masked
        isError={isError}
        onChange={props.HandleOnChangePinCode}
        testId="supervisor-pin"
      />
      <Typography
        color={isError ? colors.text.error : colors.text.primary}
        data-testid="supervisor-pin-name"
        data-pin-error={isError ? "true" : "false"}
      >
        {superVisorName}
      </Typography>
    </Stack>
  );
}
